import React, { useState } from "react";
import { getFirestore, collection, addDoc, doc, updateDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { useNavigate, useLocation } from "react-router-dom";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const New = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {}; // 수정할 데이터
  const isEdit = Boolean(state?.id); // 수정 여부 판단

  const [title, setTitle] = useState(state?.title || "");
  const [content, setContent] = useState(state?.content || "");
  const [url, setUrl] = useState(state?.url || "");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !content) {
      alert("모든 필드를 입력해주세요.");
      return;
    }

    // 현재 날짜를 YYYY-MM-DD 형식으로 가져오기
    const currentDate = new Date().toISOString().split("T")[0];

    try {
      if (isEdit) {
        // 수정 모드: Firestore 문서 업데이트
        const docRef = doc(db, "notice", state.id);
        await updateDoc(docRef, {
          title,
          content,
          url,
          date: currentDate,
        });
        alert("공지사항이 수정되었습니다.");
      } else {
        // 추가 모드: Firestore에 새 문서 추가
        await addDoc(collection(db, "notice"), {
          title,
          content,
          url,
          date: currentDate,
        });
        alert("공지사항이 추가되었습니다.");
      }

      // 초기화 및 페이지 이동
      setTitle("");
      setContent("");
      setUrl("");
      navigate("/notice");
    } catch (error) {
      console.error("Error saving document: ", error);
    }
  };

  return (
    <div className="new">
      <h4>{isEdit ? "공지 수정" : "공지 추가"}</h4>
      <p>이미지는 <a href="https://khea2.imgbb.com/" style={{color:'blue'}}>https://khea2.imgbb.com/ </a>에 업로드</p>
      <form onSubmit={handleSubmit}>
        <div className="form-table">
          <div className="form-row">
            <label className="form-label">제목</label>
            <input
              className="form-input"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className="form-row">
            <label className="form-label">내용</label>
            <textarea
              className="form-text"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
            />
          </div>
          <div className="form-row">
            <label className="form-label">이미지 링크</label>
            <input
              className="form-input"
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>
          <div className="form-row">
            <button className="form-button" type="submit">
              {isEdit ? "수정" : "추가"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default New;
